import React from 'react';
import './index.css';

import { NavLink } from 'react-router-dom';
import NavBar from '../NavBar/';

const Projects = () => (
  <div className="projects">
    <NavBar title="My Projects" />
    <div className="container">
      <div className="section">
        <h1>Main Projects</h1>

        <ul>
          <h2><NavLink to="http://notes.mattray.io" target="_blank" rel="noopener noreferrer">Notes App!</NavLink><NavLink to="https://github.com/MattRay0295/notes-app" target="_blank" rel="noopener noreferrer"><i className="fa fa-github" aria-hidden="true"></i></NavLink></h2>
          <h3>Technologies Used:</h3>
          <li>Material.io Web Components | React.js | Firebase | Firestore</li>
        </ul>
        

        <ul>
          <h2><NavLink to="http://atm.mattray.io" target="_blank" rel="noopener noreferrer">Bank Account View App</NavLink><NavLink to="https://github.com/MattRay0295/WDI-projects-assignments/tree/master/NavLinktm-react" target="_blank" rel="noopener noreferrer"><i className="fa fa-github" aria-hidden="true"></i></NavLink></h2>
          <h3>Technologies Used:</h3>
          <li>React.js | Firebase</li>
        </ul>
        
        <ul>
          <h2><NavLink to="http://quotes.mattray.io" target="_blank" rel="noopener noreferrer">Quote Machine App!</NavLink><NavLink to="https://github.com/MattRay0295/quote-machine-app" target="_blank" rel="noopener noreferrer"><i className="fa fa-github" aria-hidden="true"></i></NavLink></h2>
          <h3>Technologies Used:</h3>
          <li>React.js | Firebase / Auth</li>
        </ul>

        <ul>
          <h2><NavLink to="https://goceries.mattray.io" target="_blank" rel="noopener noreferrer">Go-Ceries App</NavLink><NavLink to="https://github.com/MattRay0295/goceries-app" target="_blank" rel="noopener noreferrer"><i className="fa fa-github" aria-hidden="true"></i></NavLink></h2>
          <h3> - made w/ Buddies, I mostly did backend</h3>
          <h3>Technologies Used:</h3>
          <li>Express.js | MongoDB | Mongoose | bcrypt | ejs</li>
        </ul>

        <ul>
          <h2><NavLink to="https://nutritionapp.mattray.io" target="_blank" rel="noopener noreferrer">Nutrition / Macrocounter App</NavLink><NavLink to="https://github.com/MattRay0295/nutrition-macrocounter-app" target="_blank" rel="noopener noreferrer"><i className="fa fa-github" aria-hidden="true"></i></NavLink></h2>
          <h3> - Quick project done in ~2.5 days</h3>
          <h3>Technologies used for Client:</h3>
          <li>React.js | Firebase | Axios | Lodash </li>
          <h3>Technologies used for Custom API Server:</h3>
          <li>Express.js | MongoDB | Mongoose | Twilio API</li>
          <h3><span className="bold">Side Note: </span>Client / Backend / MongoDB is all running alongside my LAMP stack on my VPS :)</h3>
        </ul>

        <ul>
          <h2><NavLink to="https://podster.mattray.io" target="_blank" rel="noopener noreferrer">Podster! - Podcast App</NavLink><NavLink to="https://github.com/MattRay0295/podcast-app" target="_blank" rel="noopener noreferrer"><i className="fa fa-github" aria-hidden="true"></i></NavLink></h2>
          <h3> - Quick project done in 4 days</h3>
          <h3>Technologies Used for Client:</h3>
          <li>React.js | Axios | Slick-Carousel (npm)</li>
          <h3>Technologies used for API Server:</h3>
          <li>Express.js | Axios | Audiosearch-client-node (npm)</li>
        </ul>

        <ul>
          <h2><NavLink to="http://vue.mattray.io" target="_blank" rel="noopener noreferrer">Portfolio w/ Vue.js</NavLink><NavLink to="https://github.com/MattRay0295/portfolio-with-vue" target="_blank" rel="noopener noreferrer"><i className="fa fa-github" aria-hidden="true"></i></NavLink></h2>
          <h3>Technologies Used:</h3>
          <li>Vue.js | Babel | Sass</li>
        </ul>

      </div>

      <br />

      <div className="section">
        <h1>Small / Random Projects</h1>
        <ul>
          <h2><NavLink to="http://dev.mattray.io/quakes" target="_blank" rel="noopener noreferrer">Live Earthquake Data from across the world</NavLink><NavLink to="https://github.com/MattRay0295/WDI-projects-assignments/tree/master/geoquakes" target="_blank" rel="noopener noreferrer"><i className="fa fa-github" aria-hidden="true"></i></NavLink></h2>
          <h3>Technologies Used:</h3>
          <li>Ajax | Google Maps API</li>
          <h3>Data:</h3>
          <li><NavLink to="https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/4.5_week.geojson" target="_blank">Quake Data</NavLink></li>
        </ul>

        <ul>
          <h2><NavLink to="http://dev.mattray.io/classic_snake" target="_blank" rel="noopener noreferrer">Classic Snake in Vanilla JS</NavLink><NavLink to="https://github.com/MattRay0295/snake-game-javascript" target="_blank" rel="noopener noreferrer"><i className="fa fa-github" aria-hidden="true"></i></NavLink></h2>
          <h3>Technolgies Used:</h3>
          <li>Canvas | Vanilla JavaScript</li>
        </ul>
          
        <ul>
          <h2><NavLink to="http://dev.mattray.io/reddit" target="_blank" rel="noopener noreferrer">Reddit with Ajax</NavLink><NavLink to="https://github.com/MattRay0295/WDI-projects-assignments/tree/master/NavLinkjaxify-reddit" target="_blank" rel="noopener noreferrer"><i className="fa fa-github" aria-hidden="true"></i></NavLink></h2>
          <h3>Technologies Used:</h3>
          <li>Ajax</li>
          <h3>Data:</h3>
          <li><NavLink to="https://www.reddit.com/.json">Reddit.json</NavLink></li>
        </ul>

        <ul>
          <h2><NavLink to="http://dev.mattray.io/tictactoe" target="_blank" rel="noopener noreferrer">Tic-Tac-Toe</NavLink><NavLink to="https://github.com/MattRay0295/WDI-projects-assignments/tree/master/tic-tac-toe" target="_blank" rel="noopener noreferrer"><i className="fa fa-github" aria-hidden="true"></i></NavLink></h2>
          <h3>Technolgies Used:</h3>
          <li>CSS3 | JavaScript</li>
        </ul>
      </div>
    </div>
  </div>
);

export default Projects;




// WEBPACK FOOTER //
// ./src/components/Projects/index.js